// =========================================================
// * Vue Material Dashboard - v1.5.2
// =========================================================
//
// * Product Page: https://www.creative-tim.com/product/vue-material-dashboard
// * Copyright 2024 Creative Tim (https://www.creative-tim.com)
// * Licensed under MIT (https://github.com/creativetimofficial/vue-material-dashboard/blob/master/LICENSE.md)
//
// * Coded by Creative Tim
//
// =========================================================
//
// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import VueRouter from "vue-router";
import App from "./App";

// router setup
import routes from "./routes/routes";

// Plugins
import GlobalComponents from "./globalComponents";
import GlobalDirectives from "./globalDirectives";
import Notifications from "./components/NotificationPlugin";

// MaterialDashboard plugin
import MaterialDashboard from "./material-dashboard";

import Chartist from "chartist";
import { getAuthContext } from "./authContext";
import delegateStore, { loadDelegateProfile } from "./delegateStore";

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkExactActiveClass: "nav-item active",
});

router.beforeEach(async (to, from, next) => {
  const requiresAuthContext = to.matched.some(
    (record) => record.meta && record.meta.requiresAuthContext
  );

  if (!requiresAuthContext) {
    next();
    return;
  }

  const authContext = getAuthContext();
  if (authContext) {
    await loadDelegateProfile();
    next();
    return;
  }

  next({
    path: "/auth",
    query: {
      redirect: to.fullPath,
    },
  });
});

Vue.prototype.$Chartist = Chartist;
Vue.prototype.$delegateStore = delegateStore;
Vue.prototype.$loadDelegateProfile = loadDelegateProfile;

Vue.use(VueRouter);
Vue.use(MaterialDashboard);
Vue.use(GlobalComponents);
Vue.use(GlobalDirectives);
Vue.use(Notifications);

/* eslint-disable no-new */
new Vue({
  el: "#app",
  render: (h) => h(App),
  router,
  data: {
    Chartist: Chartist,
  },
});
